import React, { useState, useEffect, useContext } from "react";
import $ from "jquery";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import axios from "axios";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import banner from "../../../images/vtc-banner.jpg";
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import up_img from "../../../images/up.png";
import middle_img from "../../../images/middle.png";
import bottom_img from "../../../images/bottom.png";
import man from "../../../images/man.png";
import house_img from "../../../images/house-img.jpg";
import CancelIcon from '@material-ui/icons/Cancel';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import AddIcon from '@material-ui/icons/Add';
import SaveIcon from '@material-ui/icons/Save';
import Footer from "../../../components/Footer/AgentFooter";
import AgentHeader from "../Header/AgentHeader";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../CommonMethods/Authentication";
import { APIURL, APIPath } from "../../../CommonMethods/Fetch";
import { postRecord } from "../../../CommonMethods/Save";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function AgentViewFlyerprint(props) {
  const [sync, setSync] = useState(true);
  const [openError, setOpenError] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
    setOpenError(false);
  };
  useEffect(() => {
    $(".gee_cross").hide();
    $(".gee_menu").hide();
  }, []);
  const ShowMenu = () => {
    $(".gee_menu").slideToggle("slow", function () {
      $(".gee_hamburger").hide();
      $(".gee_cross").show();
    });
  }
  const HideMenu = () => {
    $(".gee_menu").slideToggle("slow", function () {
      $(".gee_cross").hide();
      $(".gee_hamburger").show();
    });
  }
  return (
    <>
      <div onLoad={window.print()}>
        <AgentHeader />
        <section class="vtc_agent_banner" style={{ backgroundImage: "url(" + banner + ")" }}>
          <div class="vtc_top_menu">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12">
                  <div class="vtc_agent_menu_top">
                    <ul>
                      <li>
                        <Link to={APIPath() + "agent-dashboard"}>My Cafe</Link>
                      </li>
                     
                      <li>
                        <Link to={APIPath() + "agent-tour-list"}>Tours</Link>
                      </li>
                      <li class="active">
                        <Link to={APIPath() + "agent-flyer"}>Flyers</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "agent-video-list"}>Videos</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "agent-setting"}>Settings</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "agent-preferred-vendor"}>Preferred Vendors</Link>
                      </li>
                      <li>
                        <a href="https://www.xpressdocs.com/next/index.php?uuid=458143677bda0010f37b603828f3b783">Xpressdocs</a>
                      </li>
                      <li class="">
                        <Link to={APIPath() + "agent-support"}>Support</Link>
                      </li>
                    </ul>
                    <div class="gee_mobile">
                      <button onClick={() => ShowMenu()} class="gee_hamburger">&#9776;</button>
                      <button onClick={() => HideMenu()} class="gee_cross">&#735;</button>
                    </div>
                  </div>
                  <div class="gee_menu">
                    <ul>
                      <li class="">
                        <Link to={APIPath() + "agent-dashboard"}>My Cafe</Link>
                      </li>
                      
                      <li>
                        <Link to={APIPath() + "agent-tour-list"}>Tours</Link>
                      </li>
                      <li class="active">
                        <Link to={APIPath() + "agent-flyer"}>Flyers</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "agent-video-list"}>Videos</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "agent-setting"}>Settings</Link>
                      </li>
                      <li>
                        <Link to={APIPath() + "agent-preferred-vendor"}>Preferred Vendors</Link>
                      </li>
                      <li>
                        <a href="https://www.xpressdocs.com/next/index.php?uuid=458143677bda0010f37b603828f3b783">Xpressdocs</a>
                      </li>
                      <li>
                        <Link to={APIPath() + "agent-support"}>Support</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="banner-title"><h2>Agent View Flyer </h2>
          </div>
        </section>
        <section class="action_sec">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12 col-md-12">
                <div class="alert alert-danger" role="alert" style={{ textAlign: "center" }}>
                  Flyer Is Not Active
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
        <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
        <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={openError} autoHideDuration={3000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      </div>


    </>
  )
}